import { Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DynamicQuestionWrapper from "../../../components/DynamicQuestion/DynamicQuestionWrapper";
import { useMemo } from "react";
import { Tabs } from "../../../_constants/individualFields.constant";
import { grey } from "@mui/material/colors";
import { useSelector } from "react-redux";

const ExtraInformation = ({value}) => {
  const { t } = useTranslation();
 const {allFields}= useSelector(state => state.individualField.initialFieldsList)
    const extraInfoFields = useMemo(
        () =>
            allFields.filter(
                (field) => field.fieldDisplayPosition === `${Tabs.EXTRA_INFORMATION}`
            ),
        [allFields]
    );
    const extraInfoFieldsLimited = useMemo(
        () =>
            allFields.filter(
                (field) => field.fieldDisplayPosition === `${Tabs.EXTRA_INFORMATION_LIMITED}`
            ),
        [allFields]
    );
    return (
    <>
        <Typography
            variant="h6"
            sx={{
                px: 2,
                py: 1.5
            }}>
            {t('repairRequest.extraInformation')}
        </Typography>
        <Divider sx={{
            my: 0
        }} />
        <Grid container sx={{py: 1}} spacing={{ xs: 2, md: 0 }}>
            <Grid size={{ xs: 12, md: 6 }} sx={{ borderRight: { xs: "none", sm: "none", md: `1px dashed ${grey[200]}` } }}>
                <Grid container spacing={1} sx={{ px: 2}}>
                    <Grid size={{ xs: 12}}>
                        <Typography variant="body1">{t("buyersGuide.options.individualOption.salesPrice")}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12}}>
                        <Divider sx={{
                            my: 0
                        }} />
                    </Grid>
                </Grid>
                <DynamicQuestionWrapper questions={extraInfoFields} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Grid container spacing={1} sx={{ px: 2}}>
                    <Grid size={{ xs: 12}}>
                        <Typography variant="body1 ">{t('buyersGuide.options.individualOption.limitedWarranty')}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12}}>
                        <Divider sx={{
                            my: 0
                        }} />
                    </Grid>
                </Grid>
                <DynamicQuestionWrapper questions={extraInfoFieldsLimited} />
            </Grid>
        </Grid>
    </>
    );
};

export default ExtraInformation;
